module.exports = __webpack_public_path__ + "static/img/banner_home02.72e6fdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_home02.png
// module id = jHdz
// module chunks = 15